@if (isRegistered()) {
  <mat-icon class="{{ iconClass() }}" [svgIcon]="icon()!" attr.aria-label="{{ icon() }} icon" />
} @else if (isClass()) {
  <i class="{{ isClass().class }} {{ iconClass() }}  {{ icon() }}"></i>
} @else {
  <i class=" {{ iconClass() }} {{ icon() }} "></i>
}
